<div class="flex flex-col items-center w-full h-full " [ngClass]="{
       'min-h-30': displayType === 'SMALL'
     }">
  <!-- Fond + Image -->
  <div class=" rounded-lg w-full flex items-center justify-center h-full aspect-square relative overflow-hidden"
    [style]="cultivation.backgroundColor ? 'background-color: ' + (cultivation.backgroundColor | HexToHsl) + ';' : ''"
    [ngClass]="{
         'p-3': displayType === 'SMALL' && cultivation.backgroundColor,
         '': displayType === 'BIG',
         ' h-32': displayType === 'TINY'
       }">
    <vw-icon-svg [iconUrl]="imageUrl" fallback="plant"
      [additionalClasses]="cultivation.backgroundColor ? 'product-img cursor-pointer mx-auto h-full w-10/12 object-contain' : 'product-img cursor-pointer h-full w-full object-cover'">
    </vw-icon-svg>
    @if (cultivation.backgroundColor) {
      <div class="absolute bottom-[7%] h-[13%] w-9/12 rounded-[50%] bg-black opacity-5 blur-sm"></div>
    }
  </div>

  <!-- Texte sous l’image, caché si showName est false -->
  @if (showName) {
    <h3 class="text-sm font-semibold text-vw-ink mt-2 text-center">
      {{ cultivation.name }}
    </h3>
  }
</div>
